import { BATTLE_RULE_SET_ID } from '../rules/battleRuleSet';
import { GAME_MODE, type GameModeId } from '../types';
import { SinglePlayerMode } from './SinglePlayerMode';
import type { GameModeDefinition } from './GameMode';

/** Single-player score run with no server deadline. */
export class EndlessMode extends SinglePlayerMode {
  override readonly id: GameModeId = GAME_MODE.ENDLESS;
  override readonly roundDurationMs = null;
}

export const endlessModeDefinition: GameModeDefinition = {
  id: GAME_MODE.ENDLESS,
  requiredSeats: 1,
  defaultRuleSetId: BATTLE_RULE_SET_ID,
  create: (ruleSetId = BATTLE_RULE_SET_ID) => new EndlessMode(ruleSetId),
};
